import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './scss/style.scss'
import useToken from './useToken'
import Loader from 'react-loader-spinner'
const loading = (
  // <div className="pt-3 text-center">
  //   <div className="sk-spinner sk-spinner-pulse"></div>
  // </div>
  <div className="text-center" style={{ position: 'absolute', left: 0, right: 0, top: '50%' }}>
    <Loader type="Bars" color="#007bff" height={100} width={100} visible={true} />
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Resetpassword = React.lazy(() => import('./views/pages/resetpassword/Resetpassword'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

export default function App() {
  const { token } = useToken()

  if (!token) {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              path="/resetpassword/:userUrl"
              name="Reset Password"
              render={(props) => <Resetpassword {...props} />}
            />
            <Route exact path="/" name="Login Page" render={(props) => <Login {...props} />} />
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            {/* <Login /> */}
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    )
  }
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
          <Route
            path="/resetpassword/:userUrl"
            name="Reset Password"
            render={(props) => <Resetpassword {...props} />}
          />

          <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
          <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
          <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  )
}
